// collapsingHeader.js — the math behind the pillar tabs' collapsing hero
// (2026-10-23, iOS large-title style). Pure, unit-tested; the hook in
// src/hooks/useCollapsingHero.js applies it with transform + opacity only.
export const HERO_MIN_SCALE = 0.72;

/**
 * @param {number} scrollTop   the scroller's scrollTop
 * @param {number} heroHeight  the hero row's layout height (unchanged by the transform)
 * @returns {{ progress: number, collapsed: boolean, transform: string, opacity: number }}
 *   progress 0 at the top → 1 once the hero has scrolled past; collapsed flips
 *   at 1 (the top bar swaps to the compact "<Pillar> · <score>%" pill).
 */
export function heroCollapseState(scrollTop, heroHeight) {
  const h = Math.max(1, Number(heroHeight) || 0);
  const top = Math.max(0, Number(scrollTop) || 0);
  const progress = Math.min(1, top / h);
  const scale = 1 - (1 - HERO_MIN_SCALE) * progress;
  // The hero stays anchored to its top-left as it shrinks and follows the
  // scroll a little (parallax), so it reads as folding into the bar.
  const translateY = -Math.round(top * 0.25);
  return {
    progress,
    collapsed: progress >= 1,
    transform: `translate3d(0, ${translateY}px, 0) scale(${scale.toFixed(3)})`,
    opacity: Math.max(0, 1 - progress * 1.15),
  };
}

/** The pillar whose compact pill the top bar shows for a tab, or null (Home and the rest). */
export const PILLAR_FOR_TAB = { habits: 'habits', finances: 'finance', health: 'health', wellness: 'wellbeing' };
export const pillarIdForTab = (tab) => PILLAR_FOR_TAB[tab] || null;
